import React from 'react';
import { Box, Tooltip } from '@chakra-ui/react';
import { KTag } from '@/ui-library/components';

interface AboveRangeTagProps {
  salaryRangeText: string;
}

/**
 * Displays an "Above range" tag with a tooltip explaining that the offer salary
 * exceeds the requisition's salary range
 */
export const AboveRangeTag: React.FC<AboveRangeTagProps> = ({
  salaryRangeText,
}) => {
  return (
    <Tooltip
      label={`The salary in the offer is higher than the salary range in the requisition (${salaryRangeText})`}
      hasArrow
      placement="top"
    >
      <Box>
        <KTag
          value="Above range"
          bg="pastel-1-light"
          color="pastel-1-dark"
          whiteSpace="nowrap"
        />
      </Box>
    </Tooltip>
  );
};
